module.exports = __webpack_public_path__ + "media/שר.c94ac2c6.mp3";